import { PageHero } from "@/components/Layout";

// Shared styling wrapper for legal / policy pages.
const LegalLayout = ({ eyebrow, title, updated, children }) => (
  <>
    <PageHero eyebrow={eyebrow} title={title} />
    <section className="max-w-3xl mx-auto px-4 py-16 sm:py-20" data-testid="legal-content">
      <p className="text-sm text-[#475569] mb-8">Last updated: {updated}</p>
      <div className="prose-legal space-y-8">{children}</div>
    </section>
  </>
);

export const LegalSection = ({ heading, children }) => (
  <div>
    <h2 className="font-display font-bold text-2xl mb-3 text-[#0F2E4C]">{heading}</h2>
    <div className="text-[#475569] leading-relaxed space-y-3">{children}</div>
  </div>
);

export const ReviewNote = ({ children }) => (
  <p className="bg-[#FFF4E6] border-l-4 border-[#EAB308] px-4 py-3 text-sm text-[#0F2E4C]"><strong>Needs review:</strong> {children}</p>
);

export default LegalLayout;
